import React from 'react';
import { FixedSizeList as List } from "react-window";
import { uniqueId } from 'lodash';
import { AutoSizer } from 'react-virtualized';
import { ConversationCardModel } from '../../models/conversations';
import ConversationCardsComponent from './conversation-cards.component';
import { UtilityService } from '../../services/UtilityService';

interface Props {
    Height: number;
    ConversationCards: ConversationCardModel[];
    toggleCardActive: (id: ConversationCardModel, index: number) => void;
    scrollRef: React.MutableRefObject<any>;
    selectedConversations: string[];
    onConversationSelect: (id: ConversationCardModel) => void;
    showCheckboxes: boolean;
    handleShowMultiActionButtons: (status: boolean) => void;
    showContactInfo?: boolean;
}




const Card = ({ data, index, style }) => {
    const { cardData, toggleCardActive, onConversationSelect, selectedConversations, showCheckboxes, ShowMultiActionButtons, handleShowMultiActionButtons, showContactInfo } = data;
    let cardID = !!cardData[index]?.Campaign?.ID ? cardData[index].Campaign.ID : cardData[index]?.GroupChat ? cardData[index]?.GroupChat?.ID : UtilityService.unmaskPhoneNumber(cardData[index]?.PhoneNumber)
    const isChecked = selectedConversations.includes(cardID);
    let convData = cardData[index]

    return (
        <ConversationCardsComponent
            // id={index}
            onClick={() => toggleCardActive(convData, index)}
            style={style}
            data={cardData[index]}
            index={index}
            isChecked={isChecked}
            onConversationSelect={() => onConversationSelect(cardData[index])}
            showCheckboxes={showCheckboxes}
            isEndScroll={convData.ID === "endScroll"}
            handleShowMultiActionButtons={handleShowMultiActionButtons}
            showContactInfo={showContactInfo}
        />
    );
}


const createCardData = (cardData: ConversationCardModel[], toggleCardActive: any, selectedConversations: string[], onConversationSelect: any, showCheckboxes: boolean, handleShowMultiActionButtons?: any, showContactInfo?: boolean ) => ({

    cardData,
    toggleCardActive,
    selectedConversations,
    onConversationSelect,
    showCheckboxes,
    handleShowMultiActionButtons,
    showContactInfo
}
);

const ConversationInfiniteList = (props: Props) => {

    

    return (
        <AutoSizer>
            {({ width }) => (

                <List
                    outerRef={props.scrollRef}
                    className="List"
                    width={width}
                    height={props.Height}
                    itemCount={props.ConversationCards.length}
                    itemSize={66}
                    itemData={createCardData(props.ConversationCards, props.toggleCardActive, props.selectedConversations, props.onConversationSelect, props.showCheckboxes, props.handleShowMultiActionButtons, props.showContactInfo)}
                    // key={uniqueId()}
                    style={{ overflowX: "hidden" }}
                >
                    {Card}
                </List>
            )}
        </AutoSizer>
    )
}

export default ConversationInfiniteList